export const state = {
  user: {},
  host: ''
}
